import { useNavigate } from 'react-router-dom';
import { mapEventToImage, importAll } from '../../constants';

export default function MobileEventCard({ name, dateTime, venue, event}) {
    const images = importAll(require.context('../../assets/eventImages', false, /\.(png|jpe?g|svg)$/));
    const imageKey = mapEventToImage[event.id];
    const navigate = useNavigate();
    const date = new Date(dateTime);
    const options = {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: 'numeric', 
        minute: 'numeric'
      };
    const dateTimeString = date.toLocaleTimeString('en-US', options);

    const onClick = () => {
        navigate(`/event/${event.id}`);
    }

    return (
        <div className="mb-1" id="card" style={{ cursor: "pointer"}} onClick={onClick} >
            <div className="row no-gutters">
                <div className="col-4">
                    <img src={images[imageKey]} style={{ borderRadius: 5, maxHeight:200 }} className="img-fluid" alt=""/>
                </div>
                <div className="col-8">
                    <div className="row px-2">
                        <h6 className="card-title mb-2">{name}</h6>
                        <p className="small no-margin">{dateTimeString}</p>
                        <p className="small">{venue.name}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}